module.exports = __webpack_public_path__ + "static/media/technical.0a928fb4.svg";